// extracted by mini-css-extract-plugin
export default {"footerBg":"D-z","footerTopLinks":"E-z","footerFeedback":"F-z","footerSocial":"G-z","footerLegalLinks":"H-z","footerIconCards":"I-z","footerBotCopy":"J-z"};